const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  warehouseChange: 'warehouse-change',
  swatchChange: 'swatch-change',
  swatchesLoaded: 'swatches-loaded',
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
  favoritesUpdate: 'favorites-update',
};
